module.exports = undefined;


//////////////////
// WEBPACK FOOTER
// external "undefined"
// module id = 787
// module chunks = 0